<template>
 
    <div ref="scrollMenu"  class="scroll-menu">
   <div ref="innerScroll" class="content"  :class="{ 'children-space-evenly' : computeSpaceEven }">
      <slot>
      </slot>
      
    </div>
      <div :class="{'fader_in' : scrollHPercent<=.99 && canScroll}"  class="faded-right fader_out"></div>
      <div :class="{'fader_in' : scrollHPercent>0 && canScroll}" class="faded-left fader_out"></div>
      
    </div>
    
</template>

<script>
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'scroll-menu',
  props: {
     spaceEven:{default:true}, // if no scrolling, use if there is loading content like images
  },
  data(){
    return {
      canScroll:false,
      children:[],
      scrollHPercent:0,
      scrollWidth:0,
    }
  },
  computed:{
    computeSpaceEven(){
      if(this.canScroll){
        return false;
      }
      if(!this.spaceEven){
        return false;
      }
      
      return true;
    }
  },
  methods:{
    scroll(){
      
      var w=(this.$refs.innerScroll.scrollWidth-this.$refs.innerScroll.clientWidth);
      // percentage scrolled Horizontally;
      this.scrollHPercent = this.$refs.innerScroll.scrollLeft/w;
      

    },
    resize(){
      this.updateSize();
      this.scroll();
    },
    updateSize(){
      
      if(!this.$refs.innerScroll){
        return;
      }
      var rootWidth=this.$refs.scrollMenu.clientWidth;
      this.scrollWidth=this.$refs.innerScroll.scrollWidth;
      
      

      if(this.scrollWidth>rootWidth){
        this.canScroll=true;
      }else{
        this.canScroll=false;
      }
      
    },
    setLeftOffset(offset){
      

      this.$refs['innerScroll'].scrollLeft=offset-2;
      
    }
  },
  updated(){
     this.updateSize();
  },
  beforeDestroy(){
    this.$refs.innerScroll.removeEventListener('scroll',this.scroll)
    window.removeEventListener('resize', this.resize);
    eventBus.$off('UPDATE_SCROLLMENU',this.updateSize);
    this.$off('SET_SCROLL_MENU_OFFSET_LEFT',this.setLeftOffset);
  },
  created(){

    // this is dangerous a it listens to events not coming from children in this
    // scrollmenu, should replace with 
    this.$on('SET_SCROLL_MENU_OFFSET_LEFT',this.setLeftOffset);
  },
  mounted(){
    
    this.$refs.innerScroll.addEventListener('scroll',this.scroll);
    eventBus.$on('UPDATE_SCROLLMENU',this.updateSize);
    
    
    window.addEventListener('resize', this.resize);
   
    this.updateSize();
   
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.scroll-menu {
  position:relative;
  z-index:100;
  width:100.1%; /* fixes freezing scroll container? */
  padding:0;
  white-space: nowrap;
}
.content{
  position:relative;
  overflow: hidden;
  overflow-x: scroll!important;
  overflow-y: hidden!important;
  -webkit-overflow-scrolling: touch;
  padding-right: 1px;
}
.content::-webkit-scrollbar{
  display:none;
}
/* width of the items in the menu */
.children-space-evenly{
  display:flex;
  justify-content: space-evenly;
}
.scroll-menu>:first-child {
  padding-left:0px!important;
  margin-left:0px!important;
}
.scroll-menu>:last-child {
  padding-right:0px!important;
  margin-right:0px!important;
}
.faded-right{
  position:absolute;
  right:0;
  top:0;
  width:25px;
  height:100%;
  background-image:url('../../assets/scrollfader.png');
  background-size: 200%;
  background-position-x: 100%;
 
}
.faded-left{
  position:absolute;
  left:0;
  top:0;
  width:25px;
  height:100%;
  
  background-image:url('../../assets/scrollfader.png');
  background-size: 200%;
  background-position-x: 0%;
 
}

.fader_out{
  pointer-events:none;
   opacity:0;
   transition:opacity .25s ease-in-out;
}
.fader_in{
  opacity:.99;
}

</style>
